import React from "react";
import { useTranslation } from "react-i18next";

export function ConfirmationModal({ open, onClose }) {
    const { t } = useTranslation();

    if (!open) return null;
    return (
        <div className="modal-overlay">
            <div className="modal-application confirmation-modal">
                <div className="confirmation-content">
                    <h2 style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 600 }}>
                        {t('careers.confirmation.title')}
                    </h2>
                    <p style={{ fontFamily: "'Roboto', sans-serif", fontWeight: 300 }}>
                        {t('careers.confirmation.message')}
                    </p>
                    <p style={{ marginTop: "1em", color: "#4B4B4B", fontFamily: "'Roboto', sans-serif", fontWeight: 300 }}>
                        {t('careers.confirmation.detail')}
                    </p>
                    <button className="send-btn"
                            style={{ marginTop: "2em", fontFamily: "'Poppins', sans-serif", fontWeight: 300 }}
                            onClick={() => {
                                onClose();
                                window.location.href = "/";
                            }}
                    >
                        {t('careers.confirmation.backToSite')}
                    </button>
                </div>
            </div>
        </div>
    );
}
